import { render, staticRenderFns } from "./OrderTableV1.vue?vue&type=template&id=71db994b&scoped=true&"
import script from "./OrderTableV1.vue?vue&type=script&lang=js&"
export * from "./OrderTableV1.vue?vue&type=script&lang=js&"
import style0 from "./OrderTableV1.vue?vue&type=style&index=0&id=71db994b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71db994b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAutocomplete,VBtn,VIcon,VSimpleTable,VTooltip})
